import React, { useEffect, useState } from 'react'
import './dashboard.css';
import { Link, useNavigate } from "react-router-dom";
import { AccessTypeConstants, API_PUBLIC_HOST, API_PRIVATE_HOST, S3_HOST, AGENT_CLUSTER, DEALERPLANSLIST, MY_PROFILE, ADDZONELIST, AGRI_IMAGE, PROFILE_IMG_PNG, COORDINATOR_IMG, DEALER_IMG, NO_IMG, FARMER_ICON_IMG, OTHER_IMAGE, SERVICE_IMAGE, DEALER_FEATURE, SERVICE_PROVIDER_FEATURE, OTHER_FEATURE, INVESTOR_FEATURE, AGRI_EXPERT_CATEGORY_ID, Lead_Banner_IMG, Purchase_Banner_IMG, PURCHASE_REQUEST_BUY_LEAD_LIST, PURCHASE_REQUEST, AccessTypeOrder, accessTypeDetailsMap, CATEGORIESITEM, PROFILE_LISTS } from '@/_constant';
import { useAuthContext, useLanguageContext, useListingLimitExceedPopupToggle } from '@/hooks';
import { accessTypeName, swapLabel } from '@/utility';
import Sliders from '@/_component/public/plugins/Slider/Sliders';
import api from '@/apis/request';
import { useSelector } from 'react-redux';
import { getBuyCategoriesData, getSellCategoriesData, getServiceCategoriesData } from '@/store/reducer/categoriesListSlice/categories';
import { DialogBox, DialogBoxActions, Button } from '@/_component/Common';
import { fetchUserAccessList, fetchDealerCategories, fetchServiceProviderCategories } from '@/apis';
import PropertySearch from '@/_component/home/PropertySearch';
import TopProperties from "@/_component/home/TopProperties";
import ExclusiveProperties from "@/_component/home/ExclusiveProperties/ExclusiveProperties";
import OfflineSellingBanner from "@/_component/home/OfflineSellingBanner/OfflineSellingBanner";
import HomeCtaBanners from "@/_component/home/HomeCtaBanners/HomeCtaBanners";
import TopDealers from "@/_component/home/TopDealers/TopDealers";
import ConnectSection from "@/_component/home/ConnectSection/ConnectSection";
import DashboardProfileCard, { createDashboardProfile } from "@/_component/home/dashboard-profile-card";
import LeadsGrowBanner from "@/_component/home/LeadsGrowBanner/LeadsGrowBanner";
import { BUSINESS_DEVELOPER_FEATURE, CUSTOMER_FEATURE } from '../../../_constant/urlconstants';
const accessImageMap = {
  "access.customer": S3_HOST + "/access/Customer.png",
  "access.dealer": S3_HOST + "/access/Dealer.png",
  "access.service_provider": S3_HOST + "/access/ServiceProvider.png",
  "access.business_developer": S3_HOST + "/access/BusinessDeveloper.png",
  "access.investor": S3_HOST + "/access/investor.png",
};

export default function Dashboard() {
  const navigate = useNavigate();
  const { language } = useLanguageContext();
  const { user: userDetails, isAuth } = useAuthContext();

  const [categoriesAccessList, setCategoriesAccessList] = useState([]);
  const serviceCategoriesList = useSelector(getServiceCategoriesData);
  const [selectCategory, setSelectCategory] = useState("");
  const [reviewList, setReviewList] = useState("");
  const [assignList, setAssignList] = useState([]);
  const [recentPostData, setRecentPostData] = useState([]);
  const [agentDetails, setAgentDetails] = useState([]);
  const [agriExpertDetails, setAgriExpertDetails] = useState({});
  const [milkCollection, setMilkCollection] = useState([]);
  const [dealerCategories, setDealerCategories] = useState([]);
  const [serviceProviderCategories, setServiceProviderCategories] = useState([]);


  useEffect(() => {

    if (isAuth) {
      listUserAccessCategoriesAndAssigneeReviewRequest();
    }
  }, [isAuth]);

  useEffect(() => {
    const fetchConnectSections = async () => {
      try {
        const dealerRes = await fetchDealerCategories();
        const dealerData = dealerRes?.data?.response || dealerRes?.data;
        if (Array.isArray(dealerData)) {
          setDealerCategories(dealerData);
        } else if (dealerData && Array.isArray(dealerData.list)) {
          setDealerCategories(dealerData.list);
        } else if (dealerData && Array.isArray(dealerData.categories)) {
          setDealerCategories(dealerData.categories);
        }
      } catch (error) {
        console.error("Error fetching dealer categories", error);
      }

      try {
        const serviceRes = await fetchServiceProviderCategories();
        const serviceData = serviceRes?.data?.response || serviceRes?.data;
        if (Array.isArray(serviceData)) {
          setServiceProviderCategories(serviceData);
        } else if (serviceData && Array.isArray(serviceData.list)) {
          setServiceProviderCategories(serviceData.list);
        } else if (serviceData && Array.isArray(serviceData.categories)) {
          setServiceProviderCategories(serviceData.categories);
        }
      } catch (error) {
        console.error("Error fetching service provider categories", error);
      }
    };

    fetchConnectSections();
  }, []);

  async function listUserAccessCategoriesAndAssigneeReviewRequest(success, user, jwtToken) {
    if (!isAuth) return;
    try {
      let reviewList;
      try {
        reviewList = await api.get(API_PUBLIC_HOST + '/review/listReviewsRequestedToMe');
      } catch (error) {
        console.error("error while fetching reviews", error);
      }
      const amIAssignee = await api.get(API_PUBLIC_HOST + "/user/amIAssignee");
      const userAccessListResp = await fetchUserAccessList();
      const userAccessList = userAccessListResp.data.response;
      if (userAccessList.length > 0) {
        prepareDatalist(userAccessList, reviewList, amIAssignee)
      } else {
        navigate('/register_as', { replace: true });
      }
    } catch (error) {
      if (error.response) {
        console.log('Server responded with an error:', error.response.status);
      } else if (error.request) {
        console.log('No response received:', error.request);
      } else {
        console.log('Error:', error.message);
      }
    }
  }

  const prepareDatalist = (listUserAccessData, reviewList, amIAssignee) => {
    const ids = listUserAccessData.map((item) => item.access_id);
    listUserAccessData = listUserAccessData.filter(
      ({ access_id }, index) => !ids.includes(access_id, index + 1)
    );

    if (amIAssignee.data?.response?.list?.length) {
      setAssignList(amIAssignee.data?.response?.list[0]);

      listUserAccessData.push({
        value: 999,
        planid: 999,
        amIAssigne: true,
        user_plan_id: 999,
        category_name: 'Assignee',
        category_id: "999",
        category_display_code: 'label.assignee',
        Id: 999,
        id: 999,
        access_id: 999,
        accessId: 999,
        lang: "en",
        html: "Assignee",
        status: "APPROVED"
      })
    }

    const selectedCategory = sessionStorage.getItem("selectedDrop");
    let initialSelectCategory = null;
    if (selectedCategory && selectedCategory !== "undefined" && selectedCategory !== "null") {
      listUserAccessData?.forEach(cat => {
        if (String(cat.category_id) === String(selectedCategory)) {
          initialSelectCategory = cat;
        }
      });
    }
    if (!initialSelectCategory && listUserAccessData.length > 0) {
      initialSelectCategory = listUserAccessData[0];
    }
    if (initialSelectCategory) {
      setSelectCategory(initialSelectCategory);
    }

    setCategoriesAccessList(listUserAccessData);
    setReviewList(reviewList?.data);
  }

  useEffect(() => {
    if (isAuth && reviewList && categoriesAccessList && categoriesAccessList.length > 0) {
      const selectedData = sessionStorage.getItem('selectedDrop');
      if (selectedData && selectedData !== "undefined" && selectedData !== "null") {
        setDashboardData(selectedData, null);
      } else {
        setDashboardData(categoriesAccessList[0]?.category_id, categoriesAccessList[0]);
      }
    }
  }, [categoriesAccessList, reviewList, isAuth]);


  const setDashboardData = async (id, obj) => {
    if (!isAuth) return;
    let selectedData = categoriesAccessList.find((n) => { return String(n.category_id) === String(id); });
    if (!selectedData || selectedData === undefined) {
      selectedData = categoriesAccessList[0];
    }
    if (!selectedData) return;

    const listObject = { "category_id": 0, "assigneeUserId": "", "parent_category_id": selectedData?.category_id, "listing_id": "", "showPlanExpiredLists": true, "plan_id": "", "user_id": selectedData?.user_id, "planType": "CATEGORY" }
    const postRecent = await api.post(API_PUBLIC_HOST + '/listing/listListingWithAddons', listObject);
    setRecentPostData(postRecent.data.response.listings);
    console.log(selectedData, 'selectedData');
    sessionStorage.setItem('selectedDrop', selectedData.category_id);
    sessionStorage.setItem('selectedUserAccessId', selectedData?.access_id);
    sessionStorage.setItem('selectedCategoryName', selectedData.category_name);
    sessionStorage.setItem('selectedDropAccessType', accessTypeName(selectedData?.access_name || selectedData?.accessId || selectedData?.access_id));
    sessionStorage.setItem('selectedDropAccessDisplayCode', selectedData?.access_display_code);

    setSelectCategory(selectedData);
    if (id === "-2" || id === "168" || id === "169" || id === "-1" || id === "-4") {
      handleChangeMyPostingItem(id)
    }
  }
  /*************agent farmer mil */
  const handleChangeMyPostingItem = (id) => {
    if (!isAuth) return;
    let URL;
    if (id === "-2") {
      URL = API_PRIVATE_HOST + '/referrals/agent/onboarding/count'
    } else if (id === "-4") {
      URL = API_PUBLIC_HOST + "/userStory/getLikesCountByUserId";
    }
    let dataAPI = id !== "-4" ? api.get(URL) : api.post(URL, { userId: userDetails.id });
    dataAPI.then((response) => {
      if (id === "-2") {
        console.log(response?.data?.response);
        setAgentDetails(response?.data?.response);
      } else if (id === "-4") {
        setAgriExpertDetails(response.data.response);
      }
    });

  };

  const connectItems = [
    { label: 'Construction Materials', image: '/home-banner/connect/Construction-Materials.png' },
    { label: 'Property', image: '/home-banner/connect/Property.png' },
    { label: 'Tiles/Ceramics', image: '/home-banner/connect/TilesCeramics.png' },
    { label: 'Cement & Rebars', image: '/home-banner/connect/Cement-Rebars.png' },
    { label: 'Cement & Rebars', image: '/home-banner/connect/Cement-Rebars.png' },
    { label: 'Cement & Rebars', image: '/home-banner/connect/Cement-Rebars.png' }
  ];

  const mappedDealerItems = dealerCategories.length > 0
    ? dealerCategories.map(item => ({
      ...item,
      label: language(swapLabel(item?.displayCode)) || language(item?.displayCode) || item?.name || item?.category_name || '',
      image: item?.thumbnail_url
        ? (item.thumbnail_url.startsWith('http') ? item.thumbnail_url : `${S3_HOST}${item.thumbnail_url}`)
        : NO_IMG
    }))
    : connectItems;

  const mappedServiceProviderItems = serviceProviderCategories.length > 0
    ? serviceProviderCategories.map(item => ({
      ...item,
      label: language(swapLabel(item?.displayCode)) || language(item?.displayCode) || item?.name || item?.category_name || '',
      image: item?.thumbnail_url
        ? (item.thumbnail_url.startsWith('http') ? item.thumbnail_url : `${S3_HOST}${item.thumbnail_url}`)
        : NO_IMG
    }))
    : connectItems;

  // Navigate to categoryitem page for dealer category selection (ConnectSection click)
  const handleDealerItemClick = (item) => {
    const categoryId = item?.id || item?.category_id || item?.categoryId || "15";
    navigate(PROFILE_LISTS, { state: { categoryId, type: 'dealer' } });
  };

  const handleDealerViewAllClick = () => {
    navigate(CATEGORIESITEM, { state: JSON.stringify({ type: 'dealer', isViewAll: true }) });
  };

  // Navigate to categoryitem page for service provider category selection (ConnectSection click)
  const handleServiceProviderItemClick = (item) => {
    const categoryId = item?.id || item?.category_id || item?.categoryId || "15";
    navigate(PROFILE_LISTS, { state: { categoryId, type: 'service_provider' } });
  };

  const handleServiceProviderViewAllClick = () => {
    navigate(CATEGORIESITEM, { state: JSON.stringify({ type: 'service_provider', isViewAll: true }) });
  };

  return (
    <div style={{ backgroundColor: '#ffff', paddingBottom: '1px' }}>

      <PropertySearch />

      {isAuth && selectCategory && categoriesAccessList.length > 0 && <DashboardProfileCard
        selectedCategory={createDashboardProfile(selectCategory)}
        categories={categoriesAccessList.map(createDashboardProfile)}
        onSelectCategory={(categoryId) => setDashboardData(categoryId, null)}
        recentPostThumbnail={recentPostData?.[0]?.thumbnailUrl}
        recentPostCount={recentPostData?.length ?? 0}
      />}

      {/* <Sliders type={isAuth ? "1" : "0"} /> */}

      <LeadsGrowBanner selectCategory={selectCategory} />

      <TopProperties />

      <OfflineSellingBanner onClick={() => {
        const category = categoriesList()?.find((item) => String(item.id) === "8") || categoriesList()?.[0];
        if (!category) return;
        const customerAccess = categoriesAccessList.find(
          (access) => String(access.access_name || "").toLowerCase() === "customer"
        );
        const search = new URLSearchParams({
          postType: "customer",
          mode: "offline",
        });
        if (customerAccess?.user_plan_id) search.set("userPlanId", String(customerAccess.user_plan_id));
        navigate(`/sell/${category.key}?${search.toString()}`);
      }} />

      <ExclusiveProperties />


      <HomeCtaBanners />

      <ConnectSection
        title="Connect with Dealers"
        subtitle="Find trusted suppliers near you"
        items={mappedDealerItems}
        onItemClick={handleDealerItemClick}
        onViewAllClick={handleDealerViewAllClick}
      />

      <ConnectSection
        title="Connect with Service Provider"
        subtitle="Hire verified experts for every job"
        items={mappedServiceProviderItems}
        onItemClick={handleServiceProviderItemClick}
        onViewAllClick={handleServiceProviderViewAllClick}
      />

      {/* <TopDealers onItemClick={handleServiceProviderItemClick} /> */}


      <RegisterSection
        categoriesAccessList={categoriesAccessList}
      />

    </div>
  )
}

const SellBuySection = ({ categoriesAccessList }) => {
  const { language } = useLanguageContext();
  const [notificationPopupData, setNotificationPopupData] = useState(false);
  const [buySellToggle, setSellBuyToggle] = useState(true);
  const buyCategoriesList = useSelector(getBuyCategoriesData);
  const sellCategoriesList = useSelector(getSellCategoriesData);
  const navigate = useNavigate();

  const registerFarmer = async () => {
    const res = await api.post(API_PUBLIC_HOST + '/user/createFarmerUserAccess');
    if (res.data.response) {
      return res.data.response;
    }
    return;
  }

  const openCategorySellBuy = async (cat, id) => {
    let temp = categoriesAccessList?.find(
      (item) => String(item.access_name || "").toLowerCase() === "customer"
    );
    if (!temp) {
      const farmerAccess = await registerFarmer();
      temp = { user_plan_id: farmerAccess?.user_plan_id };
    }
    let data = categoriesList()?.find((item) => item.id === id);
    if (!data?.key) return;
    if (cat === "sell" && temp) {
      const search = new URLSearchParams({
        postType: "customer",
      });
      if (temp.user_plan_id) search.set("userPlanId", String(temp.user_plan_id));
      navigate(`/sell/${data.key}?${search.toString()}`);
    } else if (cat === "buy") {
      navigate(`/buy/${data.key}`)
    } else {
      setNotificationPopupData(true);
    }
  };

  const toggleSellBuy = (type) => {
    localStorage.setItem("buySellToggle", type)
    setSellBuyToggle(type === "sell" ? true : false);
  };

  const handleChangeClosePopup = () => {
    setNotificationPopupData(false);
  }

  const categoriesList = () => {
    if (buySellToggle) {
      return !!buyCategoriesList && buyCategoriesList;
    }
    return !!sellCategoriesList && sellCategoriesList;
  }

  const categoryCards = (categories) => {
    return categories.map((item, i) => {
      return (
        <div className="card border-0 rounded-3 kg-bg-warning text-white cursor-pointer" key={i} style={{ width: "12.9rem" }}>
          <div className="card-body p-2" onClick={() => openCategorySellBuy(buySellToggle ? 'buy' : "sell", item?.id)}>
            <img className='card-img' src={`${S3_HOST}${item.thumbnail_url}`} alt={item.name} style={{ height: '230px', "objectFit": "cover" }} />
            <p className="py-2 text-center cursor-pointer"> {language(swapLabel(item?.displayCode))}</p>
          </div>
        </div>
      );
    });
  }

  return (
    <section className="buy-sell-contianer py-5">
      <div className="container">
        <div className="row">
          <div className="d-inline-flex justify-content-center">
            <div className='bg-white rounded-pill d-flex'>
              <Button primary={buySellToggle} solid={buySellToggle} onClick={() => toggleSellBuy("sell")} rounded className="px-5 fs-4">
                <span className='px-sm-5 px-2'>{language("label.buy")}</span>
              </Button>
              <Button primary={!buySellToggle} solid={!buySellToggle} onClick={() => toggleSellBuy("buy")} rounded className="px-5 fs-4">
                <span className='px-sm-5 px-2'>{language("label.sell")}</span>
              </Button>
            </div>
          </div>
        </div>

        <div className="row">
          <p className="fs-3 fw-bold text-center py-5">
            {buySellToggle ? language("Choose_your_catagory_to_buy_your_product") : language("Choose_your_catagory_to_sell_your_product")}
          </p>
          <div className="d-flex align-items-stretch justify-content-center gap-3 flex-wrap">
            {categoryCards(categoriesList())}
          </div>
        </div>
        {
          !buySellToggle && notificationPopupData && <DialogBox title={language("label.Alert")}
            onClose={handleChangeClosePopup} >
            {language("label.alert.register.farmer_general_posting")}
          </DialogBox>
        }
      </div>
    </section>
  );
};

const ServicesSection = ({ serviceCategoriesList }) => {
  const { language } = useLanguageContext();

  const navigate = useNavigate();

  const openServicesCategory = (category) => {
    if (!category?.key) return;
    navigate(`/services/${category.key}`);
  };

  return (
    <section className="py-5">
      <div className="container">
        <h2 className="kg-title pt-4 pb-3 text-center">{language("SERVICES_WE_OFFER")}</h2>
        <p className="kg-dark-gray text-center pb-5 fs-4">{language("Get_right_services_for_your_need")}</p>

        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-4 gy-4 justify-content-center align-items-stretch px-2">
          {!!serviceCategoriesList && serviceCategoriesList?.map((item, i) => (
            item?.is_active && (
              <div className="col" key={i}>
                <div className="service-box cursor-pointer card rounded shadow-sm border-0 kg-bg-gray" onClick={() => openServicesCategory(item)}>
                  <div className="card-body p-2">
                    <img className='card-img' src={`${S3_HOST}${item.thumbnail_url}`} alt={item.name} style={{ height: '10rem', objectFit: "cover" }} />
                    <p className='pt-3 pb-2 text-center text-nowrap'>{language(item?.displayCode)}</p>
                  </div>
                </div>
              </div>
            )
          ))}
        </div>
      </div>
    </section>
  );
};

const RegisterSection = ({ categoriesAccessList }) => {
  const [notificationPopupData, setNotificationPopupData] = useState("");
  let navigate = useNavigate();
  const { language } = useLanguageContext();

  const loadRegisterForm = (type, id, item) => {
    let isExistCategories = undefined;
    isExistCategories = categoriesAccessList?.find((n) => n.category_id === id);
    if (!!isExistCategories && (["-1", "-2", "-3", "-4", "-5"].includes(id))) {
      setNotificationPopupData({ title: language(type), message: "You are already registered..." });
    } else {
      if (type === "access.customer") {
        navigate(CUSTOMER_FEATURE);
      } else if (type === "access.investor") {
        navigate(INVESTOR_FEATURE);
      } else if (type === "access.dealer") {
        navigate(DEALER_FEATURE);
      } else if (type === "access.service_provider") {
        navigate(SERVICE_PROVIDER_FEATURE);
      } else if (type === "access.business_developer") {
        navigate(BUSINESS_DEVELOPER_FEATURE);
      } else if (type === "access.others") {
        navigate(OTHER_FEATURE, { replace: true, state: JSON.stringify(item) });
      }
    }

  };

  const handleChangeClosePopup = () => {
    setNotificationPopupData("");
  }

  return (
    <section className="register py-5 bg-light">
      <div className="container kg-bg-white shadow-sm py-4 px-3 rounded-4" >
        <h3 className="fw-bold text-center kg-dark-gray mb-4">
          {language('label.you_can_register')}
        </h3>

        <div className="d-flex flex-wrap gap-1 text-nowrap px-1">
          {AccessTypeOrder
            .filter(accessType => [
              "access.customer",
              "access.dealer",
              "access.service_provider",
              "access.business_developer",
              "access.investor"
            ].includes(accessType))
            .map(accessType => {

              const accessDetails = accessTypeDetailsMap[accessType];

              return (
                <div
                  className="rounded-4 d-flex flex-column align-items-center justify-content-center flex-fill"
                  key={accessType}
                >
                  <img
                    className="img-fluid"
                    onClick={() => loadRegisterForm(accessDetails?.label, accessDetails?.categoryId)}
                    src={accessImageMap[accessType] || accessDetails.icon}
                    alt={accessDetails?.displayName}
                  />

                  <h5 className="pt-2 fw-bold">
                    {language(accessDetails?.label) ?? accessDetails?.displayName}
                  </h5>
                </div>
              );
            })}
        </div>
      </div>
      {notificationPopupData && <DialogBox
        title={notificationPopupData?.title}
        onClose={handleChangeClosePopup}
      >
        {notificationPopupData?.message}
      </DialogBox>}
    </section>
  );
};

/**
 * Modal that lets the user pick a dealer category before proceeding to DEALER_FEATURE.
 * Props:
 *   categories  – array of mapped dealer items (label + image)
 *   onSelect    – called with the chosen item
 *   onClose     – called when the modal is dismissed
 */
const DealerCategoryModal = ({ categories, onSelect, onClose }) => {
  const { language } = useLanguageContext();

  return (
    <DialogBox title={language("label.select_category") || "Select a Category"} onClose={onClose}>
      <div
        className="row g-3"
        style={{ maxHeight: '60vh', overflowY: 'auto' }}
      >
        {categories.map((item, index) => (
          <div
            key={index}
            className="col-4 col-sm-3 text-center cursor-pointer"
            onClick={() => onSelect(item)}
            style={{ minWidth: '100px' }}
          >
            <div
              className="border rounded-3 p-2 h-100 d-flex flex-column align-items-center justify-content-center"
              style={{ transition: 'box-shadow 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = '0 0 0 2px #0d6efd'}
              onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
            >
              <img
                src={item.image}
                alt={item.label}
                className="img-fluid rounded-2 mb-2"
                style={{ height: '60px', width: '60px', objectFit: 'cover' }}
              />
              <p className="mb-0 small fw-semibold text-dark" style={{ fontSize: '0.78rem', lineHeight: '1.2' }}>
                {item.label}
              </p>
            </div>
          </div>
        ))}
      </div>
    </DialogBox>
  );
};
